import MediaOverlayControlsComponent from '@wix/thunderbolt-elements/src/components/VideoBoxPlay/viewer/VideoBoxPlay';
import MediaOverlayControlsController from '@wix/thunderbolt-elements/src/components/VideoBoxPlay/viewer/VideoBoxPlay.controller';


const MediaOverlayControls = {
  component: MediaOverlayControlsComponent,
  controller: MediaOverlayControlsController
};


export const components = {
  ['MediaOverlayControls']: MediaOverlayControls
};

